export default __webpack_public_path__ + "static/media/KoalouMusicIntro.e3640117.wav";